import { Scene } from "phaser";
import { beagleJorney, getResolution } from "../lib/config";
import { changeWaypoint } from "../tweens/Tweens";
import { eventDispatcher } from "../lib/eventDispatcher";
interface SequenceItem {
  type: "anim";
  anim: any; // o el tipo específico de tl1Reverse
}

interface SequenceFunc {
  type: "function";
  func: () => void;
}

export class Game extends Scene {
  camera: Phaser.Cameras.Scene2D.Camera;
  background: Phaser.GameObjects.Image;
  jpgBg: Phaser.GameObjects.Image;
  msg_text: Phaser.GameObjects.Text;
  container: Phaser.GameObjects.Rectangle;
  waypointList: Phaser.GameObjects.Image[];
  contentList: Phaser.GameObjects.Image[];
  postalList: Object;
  activeBtn: boolean = true;
  activeClick: boolean = true;
  index: number = 0;
  waypoint: number = 0;
  cmds: any;
  constructor() {
    super("Game");
  }

  create() {
    const resolution: any = getResolution();
    //  Set the camera and physics bounds to be the size of map bg image
    this.cameras.main.setBounds(0, 0, 1920, 1080);
    this.camera = this.cameras.main;
    this.cameras.main.setZoom(1);
    this.cameras.main.centerOn(1920 / 2, 1080 / 2);

    // Set Map
    this.jpgBg = this.add.image(0, 0, "jpgMap").setOrigin(0, 0).setScale(0.48);

    // Set Waypoint List
    this.waypointList = beagleJorney.map((el, index) =>
      this.add
        .image(el.waypoint.cord[0], el.waypoint.cord[1], `wp${index + 1}`)
        .setInteractive()
        .setData({
          index,
          seqId: el.waypoint.seqId,
          x: el.waypoint.cord[0],
          y: el.waypoint.cord[1],
        })
    );
    this.contentList = beagleJorney.map((el, index) =>
      this.setTextComponent(
        el.waypoint.descriptionCord[0],
        el.waypoint.descriptionCord[1],
        el.waypoint.name
      )
    );

    // Set Interactive
    this.waypointList.forEach((wp: any, index: number) => {
      wp.on("pointerdown", () => {
        this.activeClick && this.openWaypoint(index);
      });
    });

    // Init the sequences
    const intro = this.initIntro(resolution);
    const tl1 = this.add.timeline([
      {
        at: 0,
        run: () => eventDispatcher.emit("BTN-ON"),
        tween: {
          targets: [intro.introTitle, intro.graphics, intro.introDescription],
          duration: 500,
          alpha: 0,
          ease: "Power2.easeInOut",
        },
      },
    ]);

    const seqList: (SequenceItem | SequenceFunc)[] = [
      { type: "anim", anim: tl1 },
    ];

    for (let index = 0; index < 18; index++) {
      seqList.push({
        type: "function",
        func: () => {
          this.goTo(
            beagleJorney[index].waypoint.cord[0],
            beagleJorney[index].waypoint.cord[1],
            2,
            index
          );
          this.time.delayedCall(
            500,
            () => eventDispatcher.emit("BTN-ON"),
            [],
            this
          );
        },
      });
      seqList.push({
        type: "function",
        func: () => {
          eventDispatcher.emit("POSTAL-SHOW", { name: `postal${index + 1}` });
        },
      });
      seqList.push({
        type: "function",
        func: () => {
          eventDispatcher.emit("POSTAL-HIDDEN", { name: `postal${index + 1}` });
        },
      });
    }
    // Reverse Sequence
    const tl1Reverse = this.add.timeline([
      {
        at: 0,
        run: () => eventDispatcher.emit("BTN-OFF"),
        tween: {
          targets: [intro.introTitle, intro.graphics, intro.introDescription],
          duration: 500,
          alpha: 1,
          ease: "Power2.easeInOut",
          onComplete: () => eventDispatcher.emit("BTN-ON"),
        },
      },
    ]);

    const seqListReverse: (SequenceItem | SequenceFunc)[] = [
      { type: "anim", anim: tl1Reverse },
    ];

    for (let index = 0; index < 18; index++) {
      seqListReverse.push({
        type: "function",
        func: () => {
          this.goTo(
            index == 0
              ? resolution.width / 2
              : beagleJorney[index - 1].waypoint.cord[0],
            index == 0
              ? resolution.height / 2
              : beagleJorney[index - 1].waypoint.cord[1],
            index == 0 ? 1 : 2,
            index - 1
          );
          this.time.delayedCall(
            500,
            () => eventDispatcher.emit("BTN-ON"),
            [],
            this
          );
        },
      });
      seqListReverse.push({
        type: "function",
        func: () => {
          eventDispatcher.emit("POSTAL-HIDDEN", { name: `postal${index + 1}` });
        },
      });
      seqListReverse.push({
        type: "function",
        func: () => {
          eventDispatcher.emit("POSTAL-SHOW", { name: `postal${index + 1}` });
        },
      });
    }

    // Play Sequence
    const playSequence = (index: number) => {
      if (this.activeClick && index <= seqList.length - 1) {
        if (seqList[index].type == "anim") {
          this.activeClick = false;
          eventDispatcher.emit("BTN-OFF");
          seqList[index].anim.play();
          this.time.delayedCall(500, () => (this.activeClick = true), [], this);
        } else if (seqList[index].type == "function") {
          this.activeClick = false;
          eventDispatcher.emit("BTN-OFF");
          seqList[index].func();
          this.time.delayedCall(500, () => (this.activeClick = true), [], this);
        }
        this.index = this.index + 1;
      } else if (this.activeClick && index == seqList.length) {
        this.index = 0;
        this.scene.start("GameOver");
      }
    };
    const playReverseSequence = (index: number) => {
      if (index < 0) {
        location.reload();
      }
      if (this.activeClick && index >= 0) {
        if (seqListReverse[index].type == "anim") {
          eventDispatcher.emit("BTN-OFF");
          seqListReverse[index].anim.play();
        } else if (seqListReverse[index].type == "function") {
          eventDispatcher.emit("BTN-OFF");
          seqListReverse[index].func();
        }
        this.index = this.index - 1;
      }
    };

    // Actions
    // Next
    eventDispatcher.on(
      "NEXT",
      () => {
        playSequence(this.index);
        /* eventDispatcher.emit("POSTAL-SHOW", { name: "postal10" }); */
      },
      this
    );

    // Prev
    eventDispatcher.on(
      "PREV",
      () => {
        playReverseSequence(this.index - 1);
      },
      this
    );
  }
  update() {}

  initIntro(resolution: any) {
    const graphics = this.add.graphics();

    graphics.fillStyle(0xff5c00, 0.8);
    graphics
      .fillRoundedRect(
        resolution.width / 10,
        resolution.height / 10,
        resolution.width * 0.8,
        resolution.height * 0.8,
        50
      )
      .setScrollFactor(0);
    const introTitle = this.add.text(
      0,
      0,
      "El viaje del Beagle\nCinco años de un joven naturalista por el mundo",
      {
        fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif',
        fontStyle: "bold italic",
        fontSize: resolution.width < 450 ? 18 : 54,
        wordWrap:
          resolution.width < 450 ? { width: 320, useAdvancedWrap: true } : {},
      }
    );
    introTitle
      .setPosition(
        resolution.width / 2 - introTitle.width / 2,
        resolution.height * 0.26 - introTitle.height / 2
      )
      .setScrollFactor(0);
    const introDescription = this.add
      .text(
        0,
        0,
        ` Este es el mapa del viaje de cinco años alrededor del mundo
que hizo el naturalista Charles Darwin (1809-1882) a bordo del
Beagle, bergantín de 10 cañones, 245 toneladas y más de 27
metros de largo. Un viaje que cambiaría su vida y la historia de
la humanidad, pues en este surgieron sus primeras ideas sobre
la evolución y la selección natural, subrayando que todos los
seres vivos somos parientes y que: “No es el más fuerte de las
especies el que sobrevive, tampoco es el más inteligente sino
aquel que es más adaptable al cambio”. `,
        {
          fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif',
          fontSize: resolution.width < 450 ? 18 : 50,
          wordWrap:
            resolution.width < 450 ? { width: 320, useAdvancedWrap: true } : {},
        }
      )
      .setScrollFactor(0);
    introDescription.setPosition(
      resolution.width / 2 - introDescription.width / 2,
      resolution.height / 2 -
        introDescription.height / 2 +
        introTitle.height -
        30
    );
    return { introTitle, introDescription, graphics };
  }
  setTextComponent(cordX: number, cordY: number, id: string) {
    let image = this.add
      .image(cordX, cordY, id)
      .setOrigin(0.5, 0.5)
      .setAlpha(0);

    return image;
  }
  openWaypoint(index: number) {
    this.activeClick = false;
    eventDispatcher.emit("POSTAL-HIDDEN", {});
    this.index = this.waypointList[index].getData("seqId");
    this.waypoint = index;
    this.goTo(
      this.waypointList[index].getData("x"),
      this.waypointList[index].getData("y"),
      2,
      this.waypointList[index].getData("index")
    );
    this.time.delayedCall(1500, () => (this.activeClick = true), [], this);
  }
  goTo(cordX: number, cordY: number, zoom: number, index: number) {
    // Move and Zoom
    this.camera.pan(cordX, cordY, 1500, "Sine.easeInOut");
    this.tweens.killAll();
    this.add.tween({
      targets: this.camera,
      zoom: zoom || 2,
      duration: 1500,
      ease: "Sine.easeInOut",
    });
    // Close All Info
    this.contentList.forEach((e) =>
      this.add.tween({
        targets: e,
        duration: 500,
        alpha: 0,
      })
    );
    // Open Info
    this.add.tween({
      targets: this.contentList[index],
      duration: 500,
      alpha: 1,
    });
  }
}
